import { Component, OnInit, ViewChild, OnDestroy, Renderer2, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, selectOperacionState, selectDetalleFacturaState, selectUtilsState } from 'app/store/app.states';
import { AsignarOperacion } from 'app/store/actions/operacion.actions';
import { BaseService } from 'app/services/base.service';
import { CoalService } from 'app/services/coal.service';
import { Router } from '@angular/router';
import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';
import { RelacionadosDialogComponent } from 'app/utilerias/relacionados-dialog/relacionados-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { Observable, Subscription } from 'rxjs';
import { TipoDeComprobante } from 'app/shared/enum.shared';
import { LocalStorageService } from 'app/services/local-storage.service';
const convert = require('xml-js');
// import { Impuestos } from '../../../../../../../backend/src/interfaces/interfaces';

interface Food {
    value: string;
    viewValue: string;
}
const datosTabla1: any[] = [

];
@Component({
    selector: 'app-docsRelacionados',
    templateUrl: './docsRelacionados.component.html',
    styleUrls: ['./docsRelacionados.component.scss']
})

export class DocsRelacionadosComponent implements OnInit, OnDestroy {
    /**IMPUTUS OUTPUTS */
    @Input() ltsMoneda: any[];
    @Input() ltsMetodoPago: any[];
    @Input() lsNombre: string;
    @Input() countDocsRel: number;
    @Input() dataUpdateDocsRelacionados: any;
    @Input() banderaActualizarFactura: boolean;
    @Input() ltsObjetoImpuesto: any[];
    @Input() docRel: { id: string, index: number, child?: DocsRelacionadosComponent };
    /**IMPUTUS OUTPUTS */
    // generar id unico
    index: string = Math.random().toString(36).substring(7);

    getStateOperation;
    operation;
    subscribeOperacion: any;
    idOperacion: number;
    Operacion: any;
    getStateDetalleFactura: Observable<any>;
    docsRelacionadosForm: FormGroup;
    showInput: boolean = true;
    invoicesOptions: any[] = [];
    idEmpresa: number;
    uuidPattern = /^[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}$/;

    countImpuestos: any = [];
    idDocRelacionados: string;
    updateDataImpuestos: any = [];

    private formSubscription: Subscription;
    private localStorageSubscription: Subscription;

    docError: any = {};

    constructor(
        private store: Store<AppState>,
        private fb: FormBuilder,
        private baseService: BaseService,
        private coalService: CoalService,
        private router: Router,
        public dialog: MatDialog,
        private renderer: Renderer2,
        private _snackBar: MatSnackBar,
        private localStorageService: LocalStorageService
        
    ) {
        this.getStateOperation = this.store.select(selectUtilsState);
        this.displayFn = this.displayFn.bind(this);
        // this.GetObjetoImpuesto();
        // console.log("ltsObjetoImp",this.ltsObjetoImpuesto)
    }
    ngOnDestroy(): void {
        this.baseService.postDetalleFactura(null);
        this.operation.unsubscribe();
    }

    ngOnInit(){
        this.docRel.child = this;
        this.idDocRelacionados = 'docRel' + this.countDocsRel;
        this.operation = this.getStateOperation.subscribe((stateOperation) => {
            this.idEmpresa = stateOperation?.empresaSeleccionada?.id;
        });
        console.log("int3",this.ltsObjetoImpuesto)
        // this.subscribeOperacion = this.getStateOperacion.subscribe((operacion) => {
        //     this.idOperacion = operacion.idOperacion;
        //     this.Operacion = operacion;
        // });
        this.getStateDetalleFactura = this.store.select(selectDetalleFacturaState);

        this.docsRelacionadosForm = this.fb.group({
            facturaOriginal: new FormControl('', [Validators.pattern(this.uuidPattern), Validators.required]),
            montoOriginal: new FormControl(0, Validators.required),
            noParcialidad: new FormControl(0, Validators.required),
            serie: new FormControl(''),
            folio: new FormControl(''),
            monedaDocsRel: new FormControl(null, Validators.required),
            tipoCambioDocsRel: new FormControl(0, Validators.required),
            objetoImpuesto: new FormControl(1, Validators.required),
            metodoPagoDocsRel: new FormControl(2, Validators.required),
            importeSaldoAnteriror: new FormControl(0, Validators.required),
            importePagado:new FormControl(0, Validators.required),
            saldoInsoluto: new FormControl(0, Validators.required)
        });

        // this.localStorageSubscription = this.localStorageService.allDocs$.subscribe(allDocs => {
        //     this.calcularImporteTotalPorFactura(allDocs, 'facturaOriginalBuscada');
        // });


        let lastNoParcialidad = 0 as any;
        if(this.docRel.index > 1){
            let lsJson = JSON.parse(localStorage.getItem('Pago ' + (this.docRel.index - 1)));

            // Obtener el último valor de noParcialidad
            if (lsJson['pago'].documentosRelacionados.length > 0) {
                const lastDoc = lsJson['pago'].documentosRelacionados[0];
                lastNoParcialidad = lastDoc[1].data.noParcialidad;
            }
        }
        // Incrementar noParcialidad
        const newNoParcialidad = ( parseInt(lastNoParcialidad) ?? 0 )+ 1;

        this.docsRelacionadosForm.controls.noParcialidad.setValue(newNoParcialidad);

        this.docsRelacionadosForm.controls.importePagado.valueChanges.subscribe(value => {
            if( this.docsRelacionadosForm.controls.importePagado.value > this.docsRelacionadosForm.controls.importeSaldoAnteriror.value){
                this.docsRelacionadosForm.controls.importePagado.setErrors({ 'incorrect': true });
                this.docsRelacionadosForm.controls.importePagado.markAsTouched();

                this.docError['importePagado'] = "El importe pagado no debe exceder el saldo anterior.";  
    
                // this.docsRelacionadosForm.controls.saldoInsoluto.setValue(this.docsRelacionadosForm.controls.importeSaldoAnteriror.value );
                this._snackBar.open('El importe pagado no puede ser mayor al importe saldo anterior.', 'Cerrar', {
                    duration: 5000,
                    panelClass: ['mat-toolbar', 'mat-warn']
                });
            }else if( this.docsRelacionadosForm.controls.importePagado.value < 0){
                this.docsRelacionadosForm.controls.importePagado.setErrors({ 'incorrect': true });
                this.docsRelacionadosForm.controls.importePagado.markAsTouched();

                this.docError['importePagado'] = "El importe pagado no debe contener valores negativos.";  
    
                // this.docsRelacionadosForm.controls.saldoInsoluto.setValue(this.docsRelacionadosForm.controls.importeSaldoAnteriror.value );
                this._snackBar.open('El importe pagado no debe contener valores negativos.', 'Cerrar', {
                    duration: 5000,
                    panelClass: ['mat-toolbar', 'mat-warn']
                });
            }else{
                this.docError['importePagado'] = null;
                this.docsRelacionadosForm.controls.importePagado.setErrors(null);
                this.docsRelacionadosForm.controls.importePagado.markAsUntouched();
            }
        });

        this.formSubscription = this.docsRelacionadosForm.valueChanges.subscribe(res => {
           

            let keyDocsRelacionados: number;
            let lsJson = JSON.parse(localStorage.getItem(this.lsNombre));
            lsJson['pago'].documentosRelacionados.forEach((value, key) => {
                if (value[0].id === this.idDocRelacionados) {
                    keyDocsRelacionados = key;
                };
            });
            lsJson['pago'].documentosRelacionados[keyDocsRelacionados][1].data = res;
            localStorage.removeItem(this.lsNombre);
            
            localStorage.setItem(this.lsNombre, JSON.stringify(lsJson));
            this.addMetodoPago(lsJson,'Add');
            
        });
        if (this.banderaActualizarFactura) {

            console.log("DOCS",this.dataUpdateDocsRelacionados)
            this.docsRelacionadosForm.controls.facturaOriginal.setValue(this.dataUpdateDocsRelacionados.attributes.facturaOriginal);

            this.docsRelacionadosForm.controls.montoOriginal.setValue(this.dataUpdateDocsRelacionados.attributes.montoOriginal);
            this.docsRelacionadosForm.controls.noParcialidad.setValue(this.dataUpdateDocsRelacionados.attributes.noParcialidad);
            this.docsRelacionadosForm.controls.serie.setValue(this.dataUpdateDocsRelacionados.attributes.serie);
            this.docsRelacionadosForm.controls.folio.setValue(this.dataUpdateDocsRelacionados.attributes.folio);
            this.docsRelacionadosForm.controls.monedaDocsRel.setValue(this.dataUpdateDocsRelacionados.attributes.cat_moneda.data?this.dataUpdateDocsRelacionados.attributes.cat_moneda.data.id:null);
            this.docsRelacionadosForm.controls.tipoCambioDocsRel.setValue(this.dataUpdateDocsRelacionados.attributes.tipoCambio);
            this.docsRelacionadosForm.controls.metodoPagoDocsRel.setValue(this.dataUpdateDocsRelacionados.attributes.cat_metodo_pago.data?this.dataUpdateDocsRelacionados.attributes.cat_metodo_pago.data.id:null);
            this.docsRelacionadosForm.controls.importeSaldoAnteriror.setValue(this.dataUpdateDocsRelacionados.attributes.importeSaldoAnteriror);
            this.docsRelacionadosForm.controls.importePagado.setValue(this.dataUpdateDocsRelacionados.attributes.importePagado);
            this.docsRelacionadosForm.controls.saldoInsoluto.setValue(this.dataUpdateDocsRelacionados.attributes.saldoInsoluto);
            if(this.dataUpdateDocsRelacionados.attributes.fac_com_pago_doc_imps.data.length > 0){
                console.log("si hay documentos",this.dataUpdateDocsRelacionados.attributes.fac_com_pago_doc_imps.data)
                this.getImpuestos(this.dataUpdateDocsRelacionados.attributes.fac_com_pago_doc_imps.data);
            }

                console.log("dataUpdateDocsRelacionados",this.dataUpdateDocsRelacionados)
                var objetoEncontrado = this.ltsObjetoImpuesto.find(
                  (item) => item.attributes.valor == this.dataUpdateDocsRelacionados.attributes.cat_objeto_impuesto.data.attributes.valor//this.dataUpdateDocsRelacionados?.attributes.cat_objeto_impuesto.data ?this.dataUpdateDocsRelacionados?.attributes.cat_objeto_impuesto.data.attributes.valor:0
                  )
              console.log("objetoEncontrado",objetoEncontrado)
                this.docsRelacionadosForm.controls.objetoImpuesto.setValue(objetoEncontrado?objetoEncontrado.id:null);
        }else{
            // this.GetObjetoImpuesto();
        }


        this.docsRelacionadosForm.get('importeSaldoAnteriror').valueChanges.subscribe(val => {
            this.updateSaldoInsoluto();
          });

          this.docsRelacionadosForm.get('importePagado').valueChanges.subscribe(val => {
            this.updateSaldoInsoluto();
          });
    };

    updateSaldoInsoluto() {
        const importeSaldoAnteriror = this.docsRelacionadosForm.get('importeSaldoAnteriror').value || 0;
        const importePagado = this.docsRelacionadosForm.get('importePagado').value || 0;
        this.docsRelacionadosForm.get('saldoInsoluto').setValue(importeSaldoAnteriror - importePagado);
    }

    getImpuestos = data => {
        const dataSend = {
            idComplemento: data.idComplemento,
            idDocRel: data.idDocRelacionado
        };
        console.log("getImpuestos",data)
        // this.coalService.getService(`fac-facturas/${data.idFactura}?populate[fac_complemento_pagos][populate][fac_com_pago_documentos][populate][fac_com_pago_doc_imps][populate]=*&populate[fac_complemento_pagos][fields]=id&populate[fac_complemento_pagos][populate][fac_com_pago_documentos][fields]=id&fields[0]=folio`).subscribe((res: any) => {
        // this.coalService.postService(`catalogo/selImpuestosComplemento`, dataSend).subscribe((res: any) => {
            // if (res.recordsets[0].length > 0) {
                for (let dat of data) {
                    setTimeout(() => {
                        this.updateDataImpuestos = dat;
                        this.addImpuesto();
                    }, 10);
                };
            // };
        // }, (error: any) => {
        //     console.log('Error al traer los documentos relacionado')
        // });
    };

    changeMoneda = value => {
        this.docsRelacionadosForm.controls.tipoCambioDocsRel.reset();
        if (value == 1) {
           this.docsRelacionadosForm.controls.tipoCambioDocsRel.disable();
           this.docsRelacionadosForm.controls.tipoCambioDocsRel.setValue(1);
        }else{
            this.docsRelacionadosForm.controls.tipoCambioDocsRel.enable();
        }
    };

    addImpuesto = () => {
        let keyDocsRelacionados: number;
        let lsJson = JSON.parse(localStorage.getItem(this.lsNombre));
        lsJson['pago'].documentosRelacionados.forEach((value, key) => {
            if (value[0].id === this.idDocRelacionados) {
                keyDocsRelacionados = key;
            };
        });
        this.countImpuestos.push({ id: this.countImpuestos.length === 0 ? 1 : this.countImpuestos.length });
        lsJson['pago'].documentosRelacionados[keyDocsRelacionados][2].impuestos.push([{ id: 'impuesto' + (this.countImpuestos.length === 0 ? 1 : this.countImpuestos.length) }, { data: {} }]);
        localStorage.removeItem(this.lsNombre);
        localStorage.setItem(this.lsNombre, JSON.stringify(lsJson));

        this.addMetodoPago(lsJson,'Add');

    };

    removeImpuesto = () => {
        let keyDocsRelacionados: number;
        let lsJson = JSON.parse(localStorage.getItem(this.lsNombre));
        lsJson['pago'].documentosRelacionados.forEach((value, key) => {
            if (value[0].id === this.idDocRelacionados) {
                keyDocsRelacionados = key;
            };
        });
        this.countImpuestos.splice(-1);
        lsJson['pago'].documentosRelacionados[keyDocsRelacionados][2].impuestos.splice(-1);
        localStorage.removeItem(this.lsNombre);
        localStorage.setItem(this.lsNombre, JSON.stringify(lsJson));

        this.addMetodoPago(lsJson,'Add');
    };

    getRelatedInvoices(event) {
        const value = event?.target?.value;
        // if (this.uuidPattern.test(value)) {
        //     return;
        // }
        this.store.dispatch(MostrarSpinner());
        this.coalService.getService(`fac-facturas?filters[ope_empresa][id]=${this.idEmpresa}&filters[cat_tipo_comprobante][id]=${TipoDeComprobante.Factura}&filters[fac_factura_timbre][id][$notNull]=true&populate=fac_factura_productos.pro_producto.cat_objeto_impuesto,fac_factura_timbre,ope_empresa,cli_cliente&filters[$or][0][cli_cliente][rfc][$contains]=${value}&filters[$or][1][fac_factura_timbre][uuid][$contains]=${value}&filters[$or][2][cli_cliente][nombre][$contains]=${value}`)
        .subscribe((res: any) => {
            this.store.dispatch(OcultarSpinner());
            this.showInput = false;
            this.invoicesOptions = res.data;

            setTimeout(() => {
                //this.myInputClave.nativeElement.focus();
                var element = this.renderer.selectRootElement('#myInvoiceInput'+this.index);
                element.focus();
            }, 500);
        }, (error: any) => {
            this.store.dispatch(OcultarSpinner());
        })
    }

    eraseRelatedInvoices() {
        this.showInput = true;
        this.docsRelacionadosForm.controls.facturaOriginal.setValue(null);
    }

    displayFn(id: any): string {
        if (id?.attributes) {
            return id?.attributes?.fac_factura_timbre?.data?.attributes?.uuid || '';
        } else {
            return id;
        }
    }

    optionSelected(event): void {
        const value = event?.option?.value;
        console.log(value);
        
        const xml = value?.attributes?.fac_factura_timbre?.data?.attributes?.cfdiComprobante;
        console.log(xml);
    
        if (xml) {
            try {
                const json = JSON.parse(xml);
                const montoOriginal = parseFloat(json['_attributes']['Total']) || 0;

                  // Verificar si la facturaOriginal ya existe en el localStorage
                const allDocs = JSON.parse(localStorage.getItem('allDocs')) || [];
                const facturaOriginal = value?.attributes?.fac_factura_timbre?.data?.attributes?.uuid;

                // Calcular la suma de los importes pagados utilizando el método calcularImporteTotalPorFactura
                const sumaImportesRegistrados = this.calcularImporteTotalPorFactura(allDocs, facturaOriginal);

                if (sumaImportesRegistrados > 0) {
                    // Calcular el importeSaldoAnteriror
                    const importeSaldoAnteriror = montoOriginal - sumaImportesRegistrados;

                    if (importeSaldoAnteriror <= 0) {
                        // Limpiar los controles del formulario
                        this.docsRelacionadosForm.reset();
                        this._snackBar.open('La suma total de lo pagado ya se ha completado.', 'Cerrar', {
                            duration: 5000,
                            panelClass: ['mat-toolbar', 'mat-warn']
                        });

                        return;
                    } else {
                        this.docsRelacionadosForm.controls.importeSaldoAnteriror.setValue(importeSaldoAnteriror);
                        this.docsRelacionadosForm.controls.importePagado.setValue(importeSaldoAnteriror || 0);
                    }
                }else{
                    this.docsRelacionadosForm.controls.importeSaldoAnteriror.setValue(json['_attributes']['Total'] || 0);
                    this.docsRelacionadosForm.controls.importePagado.setValue(json['_attributes']['Total'] || 0);
                }
                this.docsRelacionadosForm.controls.facturaOriginal.setValue(facturaOriginal);
                this.docsRelacionadosForm.controls.montoOriginal.setValue(montoOriginal);
                // this.docsRelacionadosForm.controls.noParcialidad.setValue(1);
                this.docsRelacionadosForm.controls.serie.setValue(json['_attributes']['Serie'] || '');
                this.docsRelacionadosForm.controls.folio.setValue(json['_attributes']['Folio'] || '');
                this.docsRelacionadosForm.controls.monedaDocsRel.setValue(this.ltsMoneda.find(x => x.attributes?.clave == json['_attributes']['Moneda'])?.id || '');
                this.docsRelacionadosForm.controls.tipoCambioDocsRel.setValue(json['_attributes']['TipoCambio'] || 1);
                this.docsRelacionadosForm.controls.metodoPagoDocsRel.setValue(this.ltsMetodoPago.find(x => x.attributes?.clave == json['_attributes']['MetodoPago'])?.id || '');
                
                this.docsRelacionadosForm.controls.saldoInsoluto.setValue(0);

            } catch (e) {
                console.error('Error al parsear el XML:', e);
                this._snackBar.open('¡Ocurrió un error al procesar los datos! Por favor, inténtalo de nuevo.', 'Cerrar', {
                    duration: 5000,
                    panelClass: ['mat-toolbar', 'mat-warn']
                });
            }
        } else {
            console.warn('No se encontró el XML en el valor seleccionado.');
            this._snackBar.open('No se encontró la información completa. Por favor, selecciona otro documento.', 'Cerrar', {
                duration: 5000,
                panelClass: ['mat-toolbar', 'mat-warn']
            });
        }
    }
    

    validateDocumento() {
        console.log("validando documento");
        this.docsRelacionadosForm.markAllAsTouched();
        this.docsRelacionadosForm.updateValueAndValidity();
        return this.docsRelacionadosForm.valid;
    }

    
    addMetodoPago = (JSON_,tipo) => {
        
        if (tipo === 'remove') {
            // Obtener el arreglo existente de documentos
            let allDocs = JSON.parse(localStorage.getItem('allDocs')) || [];
            // Filtrar el documento que se va a eliminar
            allDocs = allDocs.filter(doc => doc.lsnombre !== this.lsNombre);
            // Guardar el arreglo actualizado en el localStorage
            this.localStorageService.setAllDocs(allDocs);
        }
      
        if (tipo === 'Add') {
            // Obtener el arreglo existente de documentos
            let allDocs = JSON.parse(localStorage.getItem('allDocs')) || [];
            // Verificar si el documento ya existe
            const existingDocIndex = allDocs.findIndex(doc => doc.lsnombre === this.lsNombre);
            if (existingDocIndex !== -1) {
              // Actualizar el documento existente
              allDocs[existingDocIndex].data = JSON_;
            } else {
              // Añadir el nuevo documento al arreglo
              allDocs.push({ lsnombre: this.lsNombre, data: JSON_ });
            }
            // Guardar el arreglo actualizado en el localStorage
            this.localStorageService.setAllDocs(allDocs);
        }

    };

    calcularImporteTotalPorFactura(pagos: any, facturaOriginalBuscada: string): number {
        let importeTotal = 0;
    
        if (!pagos || pagos.length === 0) {
          console.warn("No hay pagos en el JSON.");
          return importeTotal;
        }
    
        pagos.forEach(pago => {
          if (!pago.data?.pago?.documentosRelacionados || pago.data.pago.documentosRelacionados.length === 0) {
            console.warn(`El pago "${pago.lsnombre}" no tiene documentos relacionados.`);
            return;
          }
    
          pago.data.pago.documentosRelacionados.forEach(documentoGrupo => {
            if (!documentoGrupo || documentoGrupo.length === 0) {
              console.warn(`El grupo de documentos en "${pago.lsnombre}" está vacío.`);
              return;
            }
    
            documentoGrupo.forEach(documento => {
              if (!documento?.data?.facturaOriginal) {
                console.warn(`Documento sin 'facturaOriginal' en el pago "${pago.lsnombre}".`);
                return;
              }
    
              const facturaOriginal = documento.data.facturaOriginal;
              const importePagado = documento.data.importePagado || 0;
    
              // Comprobamos si la factura original coincide con la buscada
              if (facturaOriginal === facturaOriginalBuscada) {
                importeTotal += importePagado;
              }
            });
          });
        });
    
        return importeTotal;
      }
    
    // // Ejecución del método con una factura específica
    // const facturaBuscada = "1b991fca-a7d3-455d-bc1a-32ddda5e5dbe";
    // const resultado = calcularImporteTotalPorFactura(pagos, facturaBuscada);
    // console.log(`Importe total para la factura ${facturaBuscada}:`, resultado);
    
    
    // GetObjetoImpuesto() {
    //     !this.banderaActualizarFactura ? this.store.dispatch(MostrarSpinner()):null;
    //     this.srvcoal.getService(`cat-objeto-impuestos`,).subscribe((res: any) => {
    //          ////this.store.dispatch(OcultarSpinner());;
    //         if (res.err) {
    //           // this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
    //           console.log("erro *************** 1")
    //         } else {
    //           this.lstObjetoImpuesto = res.data
    //           console.log('tipo impuesto', res.data)
    //           //this.lstObjetoImpuesto = res.recordsets[5];
    //           //actualizacion para objeto de impuestos
    //           console.log('this.banderaActualizarFactura', this.banderaActualizarFactura)
    //         //   if (this.banderaActualizarFactura) {
    //         //       console.log("dataUpdateDocsRelacionados",this.dataUpdateDocsRelacionados)
    //         //       var objetoEncontrado = this.lstObjetoImpuesto.find(
    //         //         (item) => item.attributes.valor == this.dataUpdateDocsRelacionados.attributes.cat_objeto_impuesto.data.attributes.valor//this.dataUpdateDocsRelacionados?.attributes.cat_objeto_impuesto.data ?this.dataUpdateDocsRelacionados?.attributes.cat_objeto_impuesto.data.attributes.valor:0
    //         //         )
    //         //     console.log("objetoEncontrado",objetoEncontrado)
    //         //       this.docsRelacionadosForm.controls.objetoImpuesto.setValue(objetoEncontrado?objetoEncontrado.id:null);
    //         //   }
    //           this.store.dispatch(OcultarSpinner());
    //         }
    //       }, (error: any) => {
    //           console.log("erro *************** 3", error)
    //           this.store.dispatch(OcultarSpinner());
    //           // this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
    //           // this.spinner = false;
    //       });
    //   }
};
